// extracted by mini-css-extract-plugin
export default {"waterfallConatainer":"ProductList_waterfallConatainer__yYjVP"};